import * as React from 'react';
export const nagelmackersSvg = React.forwardRef(function nagelmackersSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#457754',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        d: 'm3.625 24.65 5.601-17.4h4.482l1.123 7.613-2.242 6.524-1.443-6.503-3.039 9.766zm15.687-17.4h5.601l-5.601 17.4h-5.603z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#7B827C',
        d: 'm24.913 14.863-3.361 9.787h6.722z',
      }),
    ),
  );
});
nagelmackersSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 32 32',
};
export var nagelmackers = {
  category: 'brand',
  colorable: false,
  name: 'nagelmackers',
  svg: nagelmackersSvg,
};
